import { render } from "./VoucherPicked.vue?vue&type=template&id=87645a84&scoped=true"
import script from "./VoucherPicked.vue?vue&type=script&lang=js"
export * from "./VoucherPicked.vue?vue&type=script&lang=js"

import "./VoucherPicked.vue?vue&type=style&index=0&id=87645a84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87645a84"

export default script